/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PaymentGroupItemDto } from './paymentGroupItemDto.model';
import { SubjectContactResponseDto } from './subjectContactResponseDto.model';
import { PaymentMethodCode } from './paymentMethodCode.model';


export interface PaymentGroupDto { 
    amount: number;
    id: string;
    /**
     * True když platba je provedena bankovním převodem (PaymentMethodCode.B) a kód banky příjemce již není platný podle číselníku dtsrc_other.bank.
     */
    invalidBankAccount?: boolean;
    paymentAddresseeSubjectId?: number;
    paymentCollection: Array<PaymentGroupItemDto>;
    paymentMethod?: PaymentMethodCode;
    paymentSubject: SubjectContactResponseDto;
    payoutDate: string;
    postagePrice?: number;
    recipientAccount?: string;
    recipientAddress?: string;
    recipientAddressCity?: string;
    recipientAddressCityPart?: string;
    recipientAddressHouseNumber?: string;
    recipientAddressPartOfVillage?: string;
    recipientAddressState?: string;
    recipientAddressStreet?: string;
    recipientAddressZipcode?: string;
    recipientFirstName?: string;
    recipientIban?: string;
    recipientIdentificationNumber?: string;
    recipientName?: string;
    recipientPersonalNumber?: string;
    recipientSurname?: string;
    recipientSwift?: string;
    recipientWithdrawPostage?: boolean;
    year: number;
}
export namespace PaymentGroupDto {
}


